export default {
    employeeManagement: 'บริหารจัดการพนักงาน',
    importEmployeeList: 'นำเข้ารายชื่อพนักงาน',
    sync: 'อับเดตข้อมูลพนักงาน',
    employeeList: 'รายชื่อพนักงาน',
    employeeImage: 'รูปภาพพนักงาน'
}
